import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeConfigForum(_id:$_id){
        recordId
      }
}
`